<template>
  <section
    :style="{color:pageTextColor}"
    :class="$style.containerStyle"
    data-scroll-to="container-begin"
  >
    <div>
      <h3
        v-if="formData.email !== ''"
        :class="['c-cbr-PageSection-headline',$style.headline]"
      >{{ $t('successscreen.success_msg_with_email') }}</h3>
      <h3
        v-else
        :class="['c-cbr-PageSection-headline',$style.headline]"
      >{{ $t('successscreen.success_msg_without_email') }}</h3>
    </div>

    <div :class="$style.container">
      <!-- main div -->
      <div
        :class="parcelShopQrCodeFile ? $style.boxLeft : $style.boxsingle"
        :style="{backgroundColor:parcelShopInfoBackgroundColor}"
      >
        <div v-if="['EE','LT','LV'].includes(formData.country)">
          <!-- print yur label div -->
          <h1
            :class="[$style.title,'c-cbr-PageSection-headline']"
          >
            {{ $t('successscreen.ee_lt_lv_success_msg_print_your_label') }}</h1>

          <div>
            <h3
              :class="[$style.text,'c-cbr-PageSection-headline']"
            >{{ $t('successscreen.success_msg_parcelshop_label') }}</h3>

            <div :class="$style.btnBox">
              <obj-button
                :class="['o-button']"
                :is-disabled="false"
                :is-active="true"
                target="_blank"
                @click="downloadFile(pdfFile)"
              >{{ $t('successscreen.success_btn_label') }}</obj-button>
            </div>
            <h1
              :class="[$style.title,'c-cbr-PageSection-headline']">
              {{ $t('successscreen.ee_lt_lv_title') }}</h1>
            <p
              :class="[$style.text, 'c-cbr-PageSection-headline']"
              v-html="$t('successscreen.ee_lt_lv_hint', {parcelNumber: parcelNumberWithChecksum, interpolation: false})" />
            <div style="font-weight: bold">
              {{ $t('successscreen.ee_lt_lv_wait') }}
            </div>
            <obj-link
              v-if="timer <= 0"
              :href="'' + getCountrySpecificUrl + ''"
              target="_blank">
              <div :class="$style.btnBox">
                <obj-button
                  :class="['o-button']"
                  :is-disabled="false"
                  :is-active="true"
                  target="_blank"
                >{{ $t('successscreen.ee_lt_lv_btn') }}</obj-button>
              </div>
            </obj-link>
            <obj-link v-else>
              <div :class="$style.btnBox">
                <obj-button
                  :class="['o-button']"
                  :is-disabled="true"
                  :is-active="false"
                  target="_blank"
                >{{ $t('successscreen.ee_lt_lv_btn') }}
                  <div id="countdown_timer">
                    <span>{{ days | two_digits }}</span>
                    <span>:</span>
                    <span>{{ hours | two_digits }}</span>
                    <span>:</span>
                    <span>{{ minutes | two_digits }}</span>
                    <span>:</span>
                    <span>{{ seconds | two_digits }}</span>
                  </div>
                </obj-button>
              </div>
            </obj-link>
          </div>
        </div>
        <div v-else>
          <h1
            :class="[$style.title,'c-cbr-PageSection-headline']"
          >
            {{ $t('successscreen.success_msg_print_your_label') }}</h1>
          <h3
            :class="[$style.text,'c-cbr-PageSection-headline']"
          >{{ $t('successscreen.success_msg_parcelshop_label') }}</h3>
          <div :class="$style.btnBox">
            <obj-button
              :class="['o-button']"
              :is-disabled="false"
              :is-active="true"
              target="_blank"
              @click="downloadFile(pdfFile)"
            >{{ $t('successscreen.success_btn_label') }}</obj-button>
          </div>
        </div>
      </div>
      <!--  print yur label  div ends -->
      <div
        v-if="parcelShopQrCodeFile"
        :class="[$style.boxRight]"
        :style="{backgroundColor:parcelShopInfoBackgroundColor}"
      >
        <div>
          <!-- qr code div -->
          <h1
            :class="[$style.title,'c-cbr-PageSection-headline']"
          >{{ $t('successscreen.success_msg_we_print_for_you') }}</h1>

          <h3
            :class="[$style.text,'c-cbr-PageSection-headline']"
          >{{ parcelShopQrCodeFile ? $t('successscreen.success_msg_parcelshop_qrcode') : '' }}</h3>
        </div>

        <div :class="$style.btnBox">
          <obj-button
            v-if="parcelShopQrCodeFile"
            :is-disabled="false"
            :is-active="true"
            :is-wide="true"
            @click="downloadFile(parcelShopQrCodeFile)"
          >{{ $t('successscreen.success_btn_parcelshop_qrcode') }}</obj-button>
        </div>

        <div
          v-if="showParcelShopQrCode"
          :class="$style.successScreen">
          <img :src="parcelShopQrCodeFile" >
        </div>
      <!-- qr code div ends -->
      </div>

      <!-- main div ends -->
    </div>

    <div :class="[$style.btnDiv]">
      <!-- extra buttons div starts -->
      <obj-button
        :class="[$style.btn]"
        :is-disabled="false"
        :is-active="true"
        @click="toggleForwardEmail()"
      >{{ $t('successscreen.success_forward_email') }}</obj-button>

      <div
        v-if="showForwardEmail && !emailError"
        :class="$style.successScreen">
        <div>
          <label
            :class="$style.label"
            :style="{color: fieldTextColor}"
            class="c-cbr-FormField-label">{{ $t(label) }}</label>
        </div>
        <span
          v-if="submitted && errors.has('email')"
          class="c-cbr-FormField-error"
        >{{ errors.first('email') }}</span>

        <input
          v-validate="'required|email'"
          :class="['c-cbr-FormField-input',$style.field, { 'is-error': submitted && errors.has('email') }]"
          v-model="emailToForward"
          name="email"
          type="email"
        >

        <obj-button
          :is-active="!errors.has('email') && emailToForward!==''"
          :class="[$style.forward_btn]"
          is-wide
          @click="triggerSendConfirmationEmail()"
        >{{ $t("successscreen.success_send") }}</obj-button>
      </div>

      <div
        v-if="emailError"
        :class="['c-cbr-FormField-input', 'u-grid', 'is-c-1-1', 'o-text', 'is-centered', $style.row]"
      >{{ $t('successscreen.success_forward_email_failed') }}</div>

      <div
        v-else-if="emailSuccess"
        :class="['c-cbr-FormField-input', 'u-grid', 'o-text','is-c-1-1', 'is-centered', $style.row]"
      >{{ $t('successscreen.success_forward_email_succeeded') }}</div>
      <div>
        <obj-button
          :class="[$style.btn]"
          :is-disabled="false"
          :is-active="true"
          @click="createReturn()"
        >{{ $t('successscreen.success_btn_one_more') }}</obj-button>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { getCountrySpecificUrl } from '../../static/parcelshopSearchURLs'
import ObjButton from '../components/ObjButton.vue'
import ObjLink from '../components/ObjLink.vue'
import VueScrollTo from 'vue-scrollto'

export default {
  components: {
    ObjButton,
    ObjLink
  },

  filters: {
    two_digits(value) {
      if(value.toString().length <= 1)
      { return "0" + value.toString(); }
      return value.toString();
    }
  },

  data() {
    return {
      label: 'successscreen.success_forward_email_emailaddress',
      showForwardEmail: false,
      showParcelShopQrCode: false,
      emailToForward: '',
      errorMsg: '',
      emailSuccess: false,
      emailError: false,
      validEmail: false,
      submitted: false,
      timer: '',
      interval: '',
    }
  },

  computed: {
    ...mapState('inputData', ['pdfFile', 'parcelShopQrCodeFile', 'formData', 'parcelNumber', 'parcelNumberWithChecksum']),
    ...mapState('config', ['identifier']),
    ...mapGetters('config', [
      'pageTextColor',
      'buttonColor',
      'buttonTextColor',
      'parcelShopInfoBackgroundColor',
      'fieldTextColor'
    ]),

    timerCompleted(value) {
      return value
    },
    seconds() {
      return Math.trunc(this.timer) % 60;
    },
    minutes() {
      return Math.trunc((this.timer) / 60) % 60;
    },
    hours() {
      return Math.trunc((this.timer) / 60 / 60) % 24;
    },
    days() {
      return Math.trunc((this.timer) / 60 / 60 / 24);
    },
    getCountrySpecificUrl() {
      return getCountrySpecificUrl(this.formData.country);
    },
  },

  created() {
    this.timer = 1200
  },

  mounted() {
    if (!this.pdfFile) {
      this.createReturn()
    }
    VueScrollTo.scrollTo('[data-scroll-to="container-begin"]', {
      offset: -100,
      easing: 'ease-out',
      duration: 0
    })

    this.interval = setInterval(() => {
      this.timer--;
      this.check_timer_completed()
      }, 1000);
  },

  methods: {
    ...mapActions('inputData', ['sendConfirmationEmail'], 100),

    check_timer_completed() {
      if(this.timer <= 0) {
        clearInterval(this.interval)
      }
    },

    createReturn() {
      this.$router.push(`/m/` + this.identifier)

      window.setTimeout(() => {
        location.reload()
      }, 10)
    },

    toggleForwardEmail() {
      this.showForwardEmail = !this.showForwardEmail
      this.emailError = false
      this.emailSuccess = false
    },

    triggerSendConfirmationEmail() {
      this.submitted = true
      this.emailError = false
      this.emailSuccess = false
      this.$validator.validate().then(valid => {
        if (valid) {
          this.sendConfirmationEmail(this.emailToForward)
            .then(() => {
              this.emailSuccess = true
            })
            .then(() => {
              this.emailToForward = ''
            })
            .catch(err => {
              this.emailError = true
              this.errorMsg = err.message
            })
          this.showForwardEmail = false
        }
      })
    },
    getConfigColors() {
      return {
        backgroundColor: this.buttonColor,
        border: this.buttonColor,
        color: this.buttonTextColor
      }
    },
    downloadFile(file) {
      window.open(file, '_blank')
    }
  }
}
</script>

<style module>
.successScreen {
  display: grid;
  grid-gap: 5px;
  grid-template-columns: 100%;
  text-align: center;
  width: auto;
}

.container {
  display: flex;
  grid-auto-rows: 1fr;
    @media (max-width: 1340px) {
      display:unset;
    }
}

.boxLeft {
  text-align: center;
  padding: 1rem;
  margin: 15px auto;
  margin-right: 15px;
  background-color: #d1d3dd;
  float: left;
  max-width: 10rem;
  min-width: 35rem;
  display: grid;
  grid-template-rows: auto max-content;

  @media (max-width: 1340px) and (min-width: 600px) {
    margin: 0px auto;
    float: none;
    max-width: 35rem;
    min-width: 10rem;
  }

  @media (max-width: 600px) {
    text-align: center;
    padding: 1rem;
    float: none;
    margin-left: 30px;
    margin-right: 30px;
    max-width: 860px;
    width: auto;
    min-width: 50px;
  }
}

.boxRight {
  text-align: center;
  padding: 1rem;
  margin: 15px auto;
  margin-left: 15px;
  background-color: #d1d3dd;
  float: left;
  max-width: 10rem;
  min-width: 35rem;
  display: grid;
  grid-template-rows: auto max-content;

  @media (max-width: 1340px) and (min-width: 600px) {
    margin: 15px auto;
    float: none;
    max-width: 35rem;
    min-width: 10rem;
  }
  @media (max-width: 600px) {
    text-align: center;
    padding: 1rem;
    float: none;
    margin-left: 30px;
    margin-right: 30px;
    max-width: 860px;
    width: auto;
    min-width: 50px;
  }
}

.boxsingle {
  text-align: center;
  padding: 1rem;
  margin: 15px auto;
  background-color: #d1d3dd;
  max-width: 10rem;
  min-width: 35rem;
  display: grid;
  grid-template-rows: auto max-content;

  @media (max-width: 880px) {
    text-align: center;
    padding: 1rem;
    margin-left: 30px;
    margin-right: 30px;
    max-width: 860px;
    background-color: #d1d3dd;
    width: auto;
    min-width: 50px;
  }
}

.btn {
  text-align: center;
  margin-top: 1.25rem;
  margin-bottom: 0px;
  margin-bottom: 15px;
}

.btnBox {
  padding: 1rem;
}

.btnDiv {
  text-align: center;
  margin: 1.25rem;
  margin-left: 30px;
  margin-right: 30px;
}

.field {
  max-width: 25rem;
  margin: auto;
  margin-bottom: 0px;
}

.title {
  font-size: 1.65rem;
  padding-top: 0px;
  padding-bottom: 0px;
  margin-top: 1rem;
  @media (max-width: 599px) {
    font-size: 1.25rem;
  }
}

.text {
  font-size: 1rem;
  max-width: none;
  padding-bottom: 0px;
  padding-top: 0px;
}

.row {
  margin-top: 0.5em;
  border: #fff;
}

.label {
  max-width: 25rem;
  text-align: left;
  margin: 0 auto;
}

.forward_btn {
  font-family: TheSansGLS;
  height: 40px;
  max-width: 25rem;
  text-align: center;
  padding: 0px;
  margin-bottom: 20px;
}

.containerStyle {
  @media (max-width: 880px) {
    min-width: 50px;
  }
}

.box {
  max-width: 677px;
  margin-top: -3rem;
}

.headline{
  @media (max-width: 600px) {
    margin-left: 30px;
    margin-right: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// client/views/ManualEntrySuccess.vue